var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgQuestion = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#question_svg__filter0_ii)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 10,
  fill: "url(#question_svg__paint10_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.10547 7.91797C7.12109 7.17969 7.375 6.5918 7.86719 6.1543C8.375 5.69727 9.07031 5.46875 9.95312 5.46875C10.7852 5.46875 11.459 5.67969 11.9746 6.10156C12.4824 6.51953 12.7363 7.06445 12.7363 7.73633C12.7363 8.56836 12.3184 9.23047 11.4824 9.72266C11.0918 9.94922 10.8281 10.1523 10.6914 10.332C10.5547 10.5117 10.4863 10.7461 10.4863 11.0352V11.3457H8.93359L8.92188 11.0059C8.88281 10.5527 8.94727 10.1758 9.11523 9.875C9.2793 9.58984 9.56641 9.32617 9.97656 9.08398C10.3555 8.85742 10.6133 8.6543 10.75 8.47461C10.8906 8.29492 10.9609 8.06641 10.9609 7.78906C10.9609 7.50781 10.8594 7.27734 10.6562 7.09766C10.4492 6.91797 10.1797 6.82812 9.84766 6.82812C9.51172 6.82812 9.24023 6.92773 9.0332 7.12695C8.82617 7.32227 8.71289 7.58594 8.69336 7.91797H7.10547ZM9.73047 14.1465C9.46484 14.1465 9.24023 14.0566 9.05664 13.877C8.86914 13.7012 8.77539 13.4844 8.77539 13.2266C8.77539 12.9688 8.86914 12.75 9.05664 12.5703C9.24023 12.3945 9.46484 12.3066 9.73047 12.3066C9.99609 12.3066 10.2227 12.3945 10.4102 12.5703C10.5977 12.75 10.6914 12.9688 10.6914 13.2266C10.6914 13.4844 10.5977 13.7012 10.4102 13.877C10.2227 14.0566 9.99609 14.1465 9.73047 14.1465Z",
  fill: "#190333"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "question_svg__filter0_ii",
  x: 0,
  y: 0,
  width: 20,
  height: 20,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.65098 0 0 0 0 0.239216 0 0 0 0 0.00392157 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_innerShadow",
  result: "effect2_innerShadow"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "question_svg__paint10_linear",
  x1: 4,
  y1: 1.67846e-7,
  x2: 4,
  y2: 20,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFEBCD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E39725"
})))));
export { SvgQuestion as ReactComponent };
export default __webpack_public_path__ + "assets/icons/question.b34a28.svg";